import { Component, Input } from '@angular/core';
import { encapsulation } from '../../../encapsulation';
import { UBXFieldBase, UBXField, UBXInputTypeEnum } from '../../../../models';

@Component({
    selector: 'ubx-input',
    templateUrl: './input.component.html',
    host: { class: 'ubx-input flx f-fd:c' },
    encapsulation
})
export class UBXInputComponent extends UBXFieldBase {
    @Input() field: UBXField;

    showPassword = false;

    Type = UBXInputTypeEnum;

    iban: RegExp = new RegExp(/[0-9A-Za-z]+/);
    alphaNumeric: RegExp = new RegExp(/[A-Za-z0-9- .]+/);
    allowedKeys: Array<string> = [ 'Delete', 'Backspace', 'Tab', 'Shift', 'Home', 'End', 'ArrowLeft', 'ArrowRight' ];

    constructor() {
        super();
    }

    setPasswordState() {
        this.showPassword = this.showPassword ? false : true;
    }

    private formatInput(target: HTMLInputElement): any {
        let value = target.value;
        switch (this.field.input?.type) {
            case UBXInputTypeEnum.Iban:
                value = value.replace(/[^A-Z0-9]+/gi, '').replace(/(.{4})/g, '$1 ').toUpperCase().trim();
                break;
            default:
                value = value;
                break;
        }
        return value;
    }
    private preventInput(event: KeyboardEvent) {
        switch (this.field.input?.type) {
            case UBXInputTypeEnum.Iban:
                this.preventKey(event, this.iban);
                break;
            case UBXInputTypeEnum.AlphaNumeric:
                this.preventKey(event, this.alphaNumeric);
                break;
        }
    }

    private preventKey(event: KeyboardEvent, regex: RegExp) {
        if (this.allowedKeys.indexOf(event.key) !== -1) {
            return;
        }
        if (!regex.test(event.key)) {
            event.preventDefault();
        }
    }

    private outputModel(value: any) {
        this.model = value;
        this.modelChange.emit(this.model);
    }

    setValue(value: any): any {
        return value ? value : '';
    }

    onKeyDown(event: KeyboardEvent) {
        this.preventInput(event);
    }
    onInput(event: InputEvent) {
        const val = this.formatInput(event.target as HTMLInputElement);
        this.outputModel(val);
    }
}
